// tslint:disable
/**
 * Retailer Optin Optout configuration service
 * Retailer Optin Optout configuration service RESTful API. This service allows OptIn and Optout configuration and rules management.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmatta@pdisoftware.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AuditTrail
 */
export interface AuditTrail {
    /**
     * 
     * @type {string}
     * @memberof AuditTrail
     */
    rocId?: string;
    /**
     * 
     * @type {ConversionType}
     * @memberof AuditTrail
     */
    type?: ConversionType;
    /**
     * 
     * @type {string}
     * @memberof AuditTrail
     */
    attributeName?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditTrail
     */
    valueBefore?: string;
    /**
     * 
     * @type {string}
     * @memberof AuditTrail
     */
    valueAfter?: string;
    /**
     * Updated by username
     * @type {string}
     * @memberof AuditTrail
     */
    changedBy?: string;
    /**
     * Updated by username
     * @type {Date}
     * @memberof AuditTrail
     */
    changedAt?: Date;
}
/**
 * 
 * @export
 * @interface BooleanArrayValue
 */
export interface BooleanArrayValue extends FactValue {
    /**
     * 
     * @type {Array<boolean>}
     * @memberof BooleanArrayValue
     */
    value?: Array<boolean>;
}
/**
 * 
 * @export
 * @interface BooleanArrayValueAllOf
 */
export interface BooleanArrayValueAllOf {
    /**
     * 
     * @type {Array<boolean>}
     * @memberof BooleanArrayValueAllOf
     */
    value?: Array<boolean>;
}
/**
 * 
 * @export
 * @interface BooleanValue
 */
export interface BooleanValue extends FactValue {
    /**
     * 
     * @type {boolean}
     * @memberof BooleanValue
     */
    value?: boolean;
}
/**
 * 
 * @export
 * @interface BooleanValueAllOf
 */
export interface BooleanValueAllOf {
    /**
     * 
     * @type {boolean}
     * @memberof BooleanValueAllOf
     */
    value?: boolean;
}
/**
 * 
 * @export
 * @interface CodeListEntry
 */
export interface CodeListEntry {
    /**
     * Item ID (system id)
     * @type {number}
     * @memberof CodeListEntry
     */
    id: number;
    /**
     * Item code
     * @type {string}
     * @memberof CodeListEntry
     */
    code: string;
    /**
     * Item description
     * @type {string}
     * @memberof CodeListEntry
     */
    description: string;
}
/**
 * Condition that influence the behaviour of given fact. Fact can be set as conditionally mandatory or conditionally ignored (it\'s value does not affect given configuration at all). The behaviour is applied only when the following condition is met: A fact or property referenced in the setting must be equal to one of the values specified in the settings. 
 * @export
 * @interface Condition
 */
export interface Condition {
    /**
     * A rule code of the referenced fact
     * @type {string}
     * @memberof Condition
     */
    ruleCode?: string;
    /**
     * A fact code of the referenced fact
     * @type {string}
     * @memberof Condition
     */
    factCode?: string;
    /**
     * A name of the referenced property
     * @type {string}
     * @memberof Condition
     */
    propertyName?: string;
    /**
     * Values of the referenced fact or property
     * @type {Array<string>}
     * @memberof Condition
     */
    values?: Array<string>;
    /**
     * Behaviour of fact when condition met
     * @type {string}
     * @memberof Condition
     */
    behaviourType?: ConditionBehaviourTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Condition
     */
    priority?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum ConditionBehaviourTypeEnum {
    MANDATORY = 'MANDATORY',
    IGNORED = 'IGNORED'
}

/**
 * Type
 * @export
 * @enum {string}
 */
export enum ConversionType {
    CURRENCYCONVERSION = 'CURRENCY_CONVERSION',
    GROCERPOINTSCONVERSION = 'GROCER_POINTS_CONVERSION',
    FISCONVERSION = 'FIS_CONVERSION'
}

/**
 * 
 * @export
 * @interface DateArrayValue
 */
export interface DateArrayValue extends FactValue {
    /**
     * 
     * @type {Array<string>}
     * @memberof DateArrayValue
     */
    value?: Array<string>;
}
/**
 * 
 * @export
 * @interface DateArrayValueAllOf
 */
export interface DateArrayValueAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof DateArrayValueAllOf
     */
    value?: Array<string>;
}
/**
 * 
 * @export
 * @interface DateTimeArrayValue
 */
export interface DateTimeArrayValue extends FactValue {
    /**
     * 
     * @type {Array<Date>}
     * @memberof DateTimeArrayValue
     */
    value?: Array<Date>;
}
/**
 * 
 * @export
 * @interface DateTimeArrayValueAllOf
 */
export interface DateTimeArrayValueAllOf {
    /**
     * 
     * @type {Array<Date>}
     * @memberof DateTimeArrayValueAllOf
     */
    value?: Array<Date>;
}
/**
 * 
 * @export
 * @interface DateTimeValue
 */
export interface DateTimeValue extends FactValue {
    /**
     * 
     * @type {Date}
     * @memberof DateTimeValue
     */
    value?: Date;
}
/**
 * 
 * @export
 * @interface DateTimeValueAllOf
 */
export interface DateTimeValueAllOf {
    /**
     * 
     * @type {Date}
     * @memberof DateTimeValueAllOf
     */
    value?: Date;
}
/**
 * 
 * @export
 * @interface DateValue
 */
export interface DateValue extends FactValue {
    /**
     * 
     * @type {string}
     * @memberof DateValue
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface DateValueAllOf
 */
export interface DateValueAllOf {
    /**
     * 
     * @type {string}
     * @memberof DateValueAllOf
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface ExtendedRuleDefinition
 */
export interface ExtendedRuleDefinition extends RuleDefinition {
    /**
     * A map of fact names and their respective definitions
     * @type {{ [key: string]: FactDefinition; }}
     * @memberof ExtendedRuleDefinition
     */
    factDefinitions: { [key: string]: FactDefinition; };
}
/**
 * 
 * @export
 * @interface ExtendedRuleDefinitionAllOf
 */
export interface ExtendedRuleDefinitionAllOf {
    /**
     * A map of fact names and their respective definitions
     * @type {{ [key: string]: FactDefinition; }}
     * @memberof ExtendedRuleDefinitionAllOf
     */
    factDefinitions: { [key: string]: FactDefinition; };
}
/**
 * 
 * @export
 * @interface FactDefinition
 */
export interface FactDefinition {
    /**
     * A code uniquely identifying the fact and it\'s definition.
     * @type {string}
     * @memberof FactDefinition
     */
    factCode: string;
    /**
     * A user readable name of the fact.
     * @type {string}
     * @memberof FactDefinition
     */
    factName: string;
    /**
     * A more detailed description of the fact.
     * @type {string}
     * @memberof FactDefinition
     */
    factDescription: string;
    /**
     * 
     * @type {FactType}
     * @memberof FactDefinition
     */
    factType: FactType;
    /**
     * 
     * @type {FactDefinitionBehaviour}
     * @memberof FactDefinition
     */
    behaviour?: FactDefinitionBehaviour;
    /**
     * A set of allowed values for this fact (no other values allowed if this is specified).
     * @type {Array<string>}
     * @memberof FactDefinition
     */
    allowedValues?: Array<string>;
}
/**
 * 
 * @export
 * @interface FactDefinitionBehaviour
 */
export interface FactDefinitionBehaviour {
    /**
     * Marks a fact as always mandatory (must have non-empty value provided). If true, this fact is always mandatory
     * @type {boolean}
     * @memberof FactDefinitionBehaviour
     */
    alwaysMandatory?: boolean;
    /**
     * List of conditions that influence the behaviour of given fact. 
     * @type {Array<Condition>}
     * @memberof FactDefinitionBehaviour
     */
    conditions?: Array<Condition>;
}
/**
 * The type of the fact\'s value which can be one of the values enumerated.
 * @export
 * @enum {string}
 */
export enum FactType {
    BooleanValue = 'BooleanValue',
    StringValue = 'StringValue',
    IntegerValue = 'IntegerValue',
    NumberValue = 'NumberValue',
    DateValue = 'DateValue',
    DateTimeValue = 'DateTimeValue',
    ObjectValue = 'ObjectValue',
    BooleanArrayValue = 'BooleanArrayValue',
    StringArrayValue = 'StringArrayValue',
    IntegerArrayValue = 'IntegerArrayValue',
    NumberArrayValue = 'NumberArrayValue',
    DateArrayValue = 'DateArrayValue',
    DateTimeArrayValue = 'DateTimeArrayValue',
    ObjectArrayValue = 'ObjectArrayValue',
    UrlValue = 'UrlValue'
}

/**
 * 
 * @export
 * @interface FactValue
 */
export interface FactValue {
    /**
     * A code uniquely identifying the fact and it\'s definition.
     * @type {string}
     * @memberof FactValue
     */
    factCode: string;
    /**
     * 
     * @type {FactType}
     * @memberof FactValue
     */
    factType: FactType;
    /**
     * 
     * @type {FactDefinition}
     * @memberof FactValue
     */
    factDefinition?: FactDefinition;
}
/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * 
     * @type {any}
     * @memberof InlineObject
     */
    file?: any;
}
/**
 * 
 * @export
 * @interface IntegerArrayValue
 */
export interface IntegerArrayValue extends FactValue {
    /**
     * 
     * @type {Array<number>}
     * @memberof IntegerArrayValue
     */
    value?: Array<number>;
}
/**
 * 
 * @export
 * @interface IntegerArrayValueAllOf
 */
export interface IntegerArrayValueAllOf {
    /**
     * 
     * @type {Array<number>}
     * @memberof IntegerArrayValueAllOf
     */
    value?: Array<number>;
}
/**
 * 
 * @export
 * @interface IntegerValue
 */
export interface IntegerValue extends FactValue {
    /**
     * 
     * @type {number}
     * @memberof IntegerValue
     */
    value?: number;
}
/**
 * 
 * @export
 * @interface IntegerValueAllOf
 */
export interface IntegerValueAllOf {
    /**
     * 
     * @type {number}
     * @memberof IntegerValueAllOf
     */
    value?: number;
}
/**
 * 
 * @export
 * @interface Market
 */
export interface Market {
    /**
     * 
     * @type {number}
     * @memberof Market
     */
    id: number;
    /**
     * Market user defined key
     * @type {string}
     * @memberof Market
     */
    udk: string;
    /**
     * Market name
     * @type {string}
     * @memberof Market
     */
    name: string;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    desc?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    exception?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ModelError
     */
    stacktrace?: Array<string>;
}
/**
 * 
 * @export
 * @interface NumberArrayValue
 */
export interface NumberArrayValue extends FactValue {
    /**
     * 
     * @type {Array<number>}
     * @memberof NumberArrayValue
     */
    value?: Array<number>;
}
/**
 * 
 * @export
 * @interface NumberArrayValueAllOf
 */
export interface NumberArrayValueAllOf {
    /**
     * 
     * @type {Array<number>}
     * @memberof NumberArrayValueAllOf
     */
    value?: Array<number>;
}
/**
 * 
 * @export
 * @interface NumberValue
 */
export interface NumberValue extends FactValue {
    /**
     * 
     * @type {number}
     * @memberof NumberValue
     */
    value?: number;
}
/**
 * 
 * @export
 * @interface NumberValueAllOf
 */
export interface NumberValueAllOf {
    /**
     * 
     * @type {number}
     * @memberof NumberValueAllOf
     */
    value?: number;
}
/**
 * 
 * @export
 * @interface ObjectArrayValue
 */
export interface ObjectArrayValue extends FactValue {
    /**
     * 
     * @type {Array<object>}
     * @memberof ObjectArrayValue
     */
    value?: Array<object>;
}
/**
 * 
 * @export
 * @interface ObjectArrayValueAllOf
 */
export interface ObjectArrayValueAllOf {
    /**
     * 
     * @type {Array<object>}
     * @memberof ObjectArrayValueAllOf
     */
    value?: Array<object>;
}
/**
 * 
 * @export
 * @interface ObjectValue
 */
export interface ObjectValue extends FactValue {
    /**
     * 
     * @type {object}
     * @memberof ObjectValue
     */
    value?: object;
}
/**
 * 
 * @export
 * @interface ObjectValueAllOf
 */
export interface ObjectValueAllOf {
    /**
     * 
     * @type {object}
     * @memberof ObjectValueAllOf
     */
    value?: object;
}
/**
 * 
 * @export
 * @interface Offer
 */
export interface Offer {
    /**
     * 
     * @type {number}
     * @memberof Offer
     */
    id: number;
    /**
     * Offer user defined key
     * @type {string}
     * @memberof Offer
     */
    udk: string;
    /**
     * Offer description
     * @type {string}
     * @memberof Offer
     */
    description: string;
}
/**
 * 
 * @export
 * @interface Participant
 */
export interface Participant {
    /**
     * 
     * @type {number}
     * @memberof Participant
     */
    id: number;
    /**
     * Participant user defined key
     * @type {string}
     * @memberof Participant
     */
    udk: string;
    /**
     * Participant name
     * @type {string}
     * @memberof Participant
     */
    name: string;
}
/**
 * 
 * @export
 * @interface Program
 */
export interface Program {
    /**
     * 
     * @type {number}
     * @memberof Program
     */
    id: number;
    /**
     * Program user defined key
     * @type {string}
     * @memberof Program
     */
    udk: string;
    /**
     * Program description
     * @type {string}
     * @memberof Program
     */
    description: string;
}
/**
 * 
 * @export
 * @interface RetailerOptConfig
 */
export interface RetailerOptConfig {
    /**
     * 
     * @type {string}
     * @memberof RetailerOptConfig
     */
    id?: string;
    /**
     * Program ID (system id)
     * @type {number}
     * @memberof RetailerOptConfig
     */
    programId: number;
    /**
     * Retailer ID (system id)
     * @type {number}
     * @memberof RetailerOptConfig
     */
    retailerId: number;
    /**
     * ROC name
     * @type {string}
     * @memberof RetailerOptConfig
     */
    name: string;
    /**
     * 
     * @type {ConversionType}
     * @memberof RetailerOptConfig
     */
    type: ConversionType;
    /**
     * ROC description
     * @type {string}
     * @memberof RetailerOptConfig
     */
    description?: string;
    /**
     * ROC validity start date and time (with no offset and no timezone)
     * @type {string}
     * @memberof RetailerOptConfig
     */
    startDateTime: string;
    /**
     * ROC validity end date and time (with no offset and no timezone)
     * @type {string}
     * @memberof RetailerOptConfig
     */
    endDateTime: string;
    /**
     * Status
     * @type {string}
     * @memberof RetailerOptConfig
     */
    status: RetailerOptConfigStatusEnum;
    /**
     * Created at date and time
     * @type {Date}
     * @memberof RetailerOptConfig
     */
    createdAt?: Date;
    /**
     * Created by username
     * @type {string}
     * @memberof RetailerOptConfig
     */
    createdBy?: string;
    /**
     * Updated at date and time
     * @type {Date}
     * @memberof RetailerOptConfig
     */
    updatedAt?: Date;
    /**
     * Updated by username
     * @type {string}
     * @memberof RetailerOptConfig
     */
    updatedBy?: string;
    /**
     * The version of the ROC. Used to implement optimistic locking which prevents concurrent overwrites and enforces data consistency.
     * @type {string}
     * @memberof RetailerOptConfig
     */
    version?: string;
    /**
     * A List of Rules that are configured in this configuration.
     * @type {Array<Rule>}
     * @memberof RetailerOptConfig
     */
    rules?: Array<Rule>;
}

/**
    * @export
    * @enum {string}
    */
export enum RetailerOptConfigStatusEnum {
    ENABLED = 'ENABLED',
    DISABLED = 'DISABLED',
    DRAFT = 'DRAFT'
}

/**
 * 
 * @export
 * @interface Rule
 */
export interface Rule {
    /**
     * The definition of the rule.
     * @type {RuleDefinition}
     * @memberof Rule
     */
    ruleDefinition?: RuleDefinition;
    /**
     * The code of the rule.
     * @type {string}
     * @memberof Rule
     */
    ruleCode: string;
    /**
     * The version of the rule.
     * @type {string}
     * @memberof Rule
     */
    ruleVersion: string;
    /**
     * The fact values associated to this rule. Each of the entries in the collection can be of a different type derived from the FactValue type. The following types are supported: <table>   <tr>     <th>type</th>     <th>definition</th>   </tr>   <tr>     <td>BooleanValue</td>     <td>#/components/schemas/BooleanValue</td>   </tr>   <tr>     <td>StringValue</td>     <td>#/components/schemas/StringValue</td>   </tr>   <tr>     <td>IntegerValue</td>     <td>#/components/schemas/IntegerValue</td>   <tr>     <td>NumberValue</td>     <td>#/components/schemas/NumberValue</td>   <tr>     <td>DateValue</td>     <td>#/components/schemas/DateValue</td>   <tr>     <td>DateTimeValue</td>     <td>#/components/schemas/DateTimeValue</td>   <tr>     <td>ObjectValue</td>     <td>#/components/schemas/ObjectValue</td>   <tr>     <td>BooleanArrayValue</td>     <td>#/components/schemas/BooleanArrayValue</td>   <tr>     <td>StringArrayValue</td>     <td>#/components/schemas/StringArrayValue</td>   <tr>     <td>IntegerArrayValue</td>     <td>#/components/schemas/IntegerArrayValue</td>   <tr>     <td>NumberArrayValue</td>     <td>#/components/schemas/NumberArrayValue</td>   <tr>     <td>DateArrayValue</td>     <td>#/components/schemas/DateArrayValue</td>   <tr>     <td>DateTimeArrayValue</td>     <td>#/components/schemas/DateTimeArrayValue</td>   <tr>     <td>ObjectArrayValue</td>     <td>#/components/schemas/ObjectArrayValue</td>   </tr>   <tr>     <td>UrlValue</td>     <td>#/components/schemas/UrlValue</td>   </tr> </table> 
     * @type {Array<FactValue>}
     * @memberof Rule
     */
    factValues: Array<FactValue>;
}
/**
 * 
 * @export
 * @interface RuleDefinition
 */
export interface RuleDefinition {
    /**
     * A code uniquely identifying the rule and it\'s definition.
     * @type {string}
     * @memberof RuleDefinition
     */
    ruleCode: string;
    /**
     * The version of the the rule and it\'s definition.
     * @type {string}
     * @memberof RuleDefinition
     */
    ruleVersion: string;
    /**
     * A user readable name of the rule.
     * @type {string}
     * @memberof RuleDefinition
     */
    ruleName: string;
}
/**
 * 
 * @export
 * @interface StringArrayValue
 */
export interface StringArrayValue extends FactValue {
    /**
     * 
     * @type {Array<string>}
     * @memberof StringArrayValue
     */
    value?: Array<string>;
}
/**
 * 
 * @export
 * @interface StringArrayValueAllOf
 */
export interface StringArrayValueAllOf {
    /**
     * 
     * @type {Array<string>}
     * @memberof StringArrayValueAllOf
     */
    value?: Array<string>;
}
/**
 * 
 * @export
 * @interface StringValue
 */
export interface StringValue extends FactValue {
    /**
     * 
     * @type {string}
     * @memberof StringValue
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface StringValueAllOf
 */
export interface StringValueAllOf {
    /**
     * 
     * @type {string}
     * @memberof StringValueAllOf
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface UploadedAsset
 */
export interface UploadedAsset {
    /**
     * 
     * @type {string}
     * @memberof UploadedAsset
     */
    publicUrl?: string;
}
/**
 * 
 * @export
 * @interface UrlValue
 */
export interface UrlValue extends FactValue {
    /**
     * 
     * @type {string}
     * @memberof UrlValue
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface UrlValueAllOf
 */
export interface UrlValueAllOf {
    /**
     * 
     * @type {string}
     * @memberof UrlValueAllOf
     */
    value?: string;
}

/**
 * APApi - axios parameter creator
 * @export
 */
export const APApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new Retailer OptIn OptOut configuration
         * @param {RetailerOptConfig} retailerOptConfig Basic ROC data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConfiguration(retailerOptConfig: RetailerOptConfig, options: any = {}): RequestArgs {
            // verify required parameter 'retailerOptConfig' is not null or undefined
            if (retailerOptConfig === null || retailerOptConfig === undefined) {
                throw new RequiredError('retailerOptConfig','Required parameter retailerOptConfig was null or undefined when calling createConfiguration.');
            }
            const localVarPath = `/configurations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["create:roc", "read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof retailerOptConfig !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(retailerOptConfig !== undefined ? retailerOptConfig : {}) : (retailerOptConfig || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a CodeList by name
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCodeListByName(name: string, options: any = {}): RequestArgs {
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling getCodeListByName.');
            }
            const localVarPath = `/codelists/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read audit trails of changes made to an existing Retailer OptIn OptOut Configuration
         * @param {string} [id] ID of Retailer OptIn OptOut Configuration for which the list of audit trails are filtered
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationAuditTrails(id?: string, options: any = {}): RequestArgs {
            const localVarPath = `/audittrails`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["delete:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read an ROC entry
         * @param {string} id ID of ROC to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationByID(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getConfigurationByID.');
            }
            const localVarPath = `/configurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read the rules for an existing Retailer OptIn OptOut Configuration
         * @param {string} id ID of Retailer OptIn OptOut Configuration to read the rules from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationRules(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getConfigurationRules.');
            }
            const localVarPath = `/configurations/{id}/rules`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all Retailer OptIn OptOut configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurations(options: any = {}): RequestArgs {
            const localVarPath = `/configurations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a single Market
         * @param {number} id ID of Market to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketById(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getMarketById.');
            }
            const localVarPath = `/markets/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read filtered list of markets
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkets(searchTerm?: string, options: any = {}): RequestArgs {
            const localVarPath = `/markets`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a single Offer
         * @param {number} id ID of Offer to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferById(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getOfferById.');
            }
            const localVarPath = `/offers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read filtered list of offers
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffers(searchTerm?: string, options: any = {}): RequestArgs {
            const localVarPath = `/offers`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a single Participant
         * @param {number} id ID of Participant to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantById(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getParticipantById.');
            }
            const localVarPath = `/participants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read filtered list of participants
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipants(searchTerm?: string, options: any = {}): RequestArgs {
            const localVarPath = `/participants`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read filtered list of participants
         * @param {Array<number>} [marketIds] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantsByMarketIds(marketIds?: Array<number>, searchTerm?: string, options: any = {}): RequestArgs {
            const localVarPath = `/markets/participantLabels`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (marketIds) {
                localVarQueryParameter['marketIds'] = marketIds;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a single Program
         * @param {number} id ID of Program to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgramById(id: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getProgramById.');
            }
            const localVarPath = `/programs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read filtered list of programs
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrograms(searchTerm?: string, options: any = {}): RequestArgs {
            const localVarPath = `/programs`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all provided rule definitions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleDefinitions(options: any = {}): RequestArgs {
            const localVarPath = `/ruleDefinitions`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing Retailer OptIn OptOut configuration
         * @param {string} id ID of ROC to update
         * @param {string} ifMatch Version of the ROC which was being modified. Used to avoid lost updates of this entity in case someone else updates this entity at the same time.
         * @param {RetailerOptConfig} retailerOptConfig Retailer OptIn OptOut Configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfiguration(id: string, ifMatch: string, retailerOptConfig: RetailerOptConfig, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateConfiguration.');
            }
            // verify required parameter 'ifMatch' is not null or undefined
            if (ifMatch === null || ifMatch === undefined) {
                throw new RequiredError('ifMatch','Required parameter ifMatch was null or undefined when calling updateConfiguration.');
            }
            // verify required parameter 'retailerOptConfig' is not null or undefined
            if (retailerOptConfig === null || retailerOptConfig === undefined) {
                throw new RequiredError('retailerOptConfig','Required parameter retailerOptConfig was null or undefined when calling updateConfiguration.');
            }
            const localVarPath = `/configurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["update:roc", "read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (ifMatch !== undefined && ifMatch !== null) {
                localVarHeaderParameter['If-Match'] = String(ifMatch);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof retailerOptConfig !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(retailerOptConfig !== undefined ? retailerOptConfig : {}) : (retailerOptConfig || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update rules for the Retailer OptIn OptOut Configuration
         * @param {string} id ID of Retailer OptIn OptOut Configuration to update rule for
         * @param {string} ifMatch Version of the Retailer OptIn OptOut Configuration which was being modified. Used to avoid lost updates of this entity in case someone else updates this entity at the same time.
         * @param {Array<Rule>} rule Rules list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfigurationRules(id: string, ifMatch: string, rule: Array<Rule>, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateConfigurationRules.');
            }
            // verify required parameter 'ifMatch' is not null or undefined
            if (ifMatch === null || ifMatch === undefined) {
                throw new RequiredError('ifMatch','Required parameter ifMatch was null or undefined when calling updateConfigurationRules.');
            }
            // verify required parameter 'rule' is not null or undefined
            if (rule === null || rule === undefined) {
                throw new RequiredError('rule','Required parameter rule was null or undefined when calling updateConfigurationRules.');
            }
            const localVarPath = `/configurations/{id}/rules`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["update:roc", "read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (ifMatch !== undefined && ifMatch !== null) {
                localVarHeaderParameter['If-Match'] = String(ifMatch);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof rule !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(rule !== undefined ? rule : {}) : (rule || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload an (image) asset
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAsset(file?: any, options: any = {}): RequestArgs {
            const localVarPath = `/assets`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["create:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * APApi - functional programming interface
 * @export
 */
export const APApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new Retailer OptIn OptOut configuration
         * @param {RetailerOptConfig} retailerOptConfig Basic ROC data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConfiguration(retailerOptConfig: RetailerOptConfig, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetailerOptConfig> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).createConfiguration(retailerOptConfig, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read a CodeList by name
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCodeListByName(name: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CodeListEntry>> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).getCodeListByName(name, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read audit trails of changes made to an existing Retailer OptIn OptOut Configuration
         * @param {string} [id] ID of Retailer OptIn OptOut Configuration for which the list of audit trails are filtered
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationAuditTrails(id?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuditTrail>> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).getConfigurationAuditTrails(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read an ROC entry
         * @param {string} id ID of ROC to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationByID(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetailerOptConfig> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).getConfigurationByID(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read the rules for an existing Retailer OptIn OptOut Configuration
         * @param {string} id ID of Retailer OptIn OptOut Configuration to read the rules from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationRules(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Rule>> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).getConfigurationRules(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read all Retailer OptIn OptOut configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurations(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RetailerOptConfig>> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).getConfigurations(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read a single Market
         * @param {number} id ID of Market to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketById(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Market> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).getMarketById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read filtered list of markets
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkets(searchTerm?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Market>> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).getMarkets(searchTerm, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read a single Offer
         * @param {number} id ID of Offer to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferById(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Offer> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).getOfferById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read filtered list of offers
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffers(searchTerm?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Offer>> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).getOffers(searchTerm, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read a single Participant
         * @param {number} id ID of Participant to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantById(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Participant> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).getParticipantById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read filtered list of participants
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipants(searchTerm?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Participant>> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).getParticipants(searchTerm, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read filtered list of participants
         * @param {Array<number>} [marketIds] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantsByMarketIds(marketIds?: Array<number>, searchTerm?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Participant>> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).getParticipantsByMarketIds(marketIds, searchTerm, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read a single Program
         * @param {number} id ID of Program to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgramById(id: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Program> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).getProgramById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read filtered list of programs
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrograms(searchTerm?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Program>> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).getPrograms(searchTerm, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read all provided rule definitions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleDefinitions(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExtendedRuleDefinition>> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).getRuleDefinitions(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update an existing Retailer OptIn OptOut configuration
         * @param {string} id ID of ROC to update
         * @param {string} ifMatch Version of the ROC which was being modified. Used to avoid lost updates of this entity in case someone else updates this entity at the same time.
         * @param {RetailerOptConfig} retailerOptConfig Retailer OptIn OptOut Configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfiguration(id: string, ifMatch: string, retailerOptConfig: RetailerOptConfig, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetailerOptConfig> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).updateConfiguration(id, ifMatch, retailerOptConfig, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Update rules for the Retailer OptIn OptOut Configuration
         * @param {string} id ID of Retailer OptIn OptOut Configuration to update rule for
         * @param {string} ifMatch Version of the Retailer OptIn OptOut Configuration which was being modified. Used to avoid lost updates of this entity in case someone else updates this entity at the same time.
         * @param {Array<Rule>} rule Rules list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfigurationRules(id: string, ifMatch: string, rule: Array<Rule>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Rule>> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).updateConfigurationRules(id, ifMatch, rule, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Upload an (image) asset
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAsset(file?: any, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadedAsset> {
            const localVarAxiosArgs = APApiAxiosParamCreator(configuration).uploadAsset(file, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * APApi - factory interface
 * @export
 */
export const APApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create a new Retailer OptIn OptOut configuration
         * @param {RetailerOptConfig} retailerOptConfig Basic ROC data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createConfiguration(retailerOptConfig: RetailerOptConfig, options?: any): AxiosPromise<RetailerOptConfig> {
            return APApiFp(configuration).createConfiguration(retailerOptConfig, options)(axios, basePath);
        },
        /**
         * 
         * @summary Read a CodeList by name
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCodeListByName(name: string, options?: any): AxiosPromise<Array<CodeListEntry>> {
            return APApiFp(configuration).getCodeListByName(name, options)(axios, basePath);
        },
        /**
         * 
         * @summary Read audit trails of changes made to an existing Retailer OptIn OptOut Configuration
         * @param {string} [id] ID of Retailer OptIn OptOut Configuration for which the list of audit trails are filtered
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationAuditTrails(id?: string, options?: any): AxiosPromise<Array<AuditTrail>> {
            return APApiFp(configuration).getConfigurationAuditTrails(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Read an ROC entry
         * @param {string} id ID of ROC to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationByID(id: string, options?: any): AxiosPromise<RetailerOptConfig> {
            return APApiFp(configuration).getConfigurationByID(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Read the rules for an existing Retailer OptIn OptOut Configuration
         * @param {string} id ID of Retailer OptIn OptOut Configuration to read the rules from
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationRules(id: string, options?: any): AxiosPromise<Array<Rule>> {
            return APApiFp(configuration).getConfigurationRules(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Read all Retailer OptIn OptOut configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurations(options?: any): AxiosPromise<Array<RetailerOptConfig>> {
            return APApiFp(configuration).getConfigurations(options)(axios, basePath);
        },
        /**
         * 
         * @summary Read a single Market
         * @param {number} id ID of Market to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketById(id: number, options?: any): AxiosPromise<Market> {
            return APApiFp(configuration).getMarketById(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Read filtered list of markets
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarkets(searchTerm?: string, options?: any): AxiosPromise<Array<Market>> {
            return APApiFp(configuration).getMarkets(searchTerm, options)(axios, basePath);
        },
        /**
         * 
         * @summary Read a single Offer
         * @param {number} id ID of Offer to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfferById(id: number, options?: any): AxiosPromise<Offer> {
            return APApiFp(configuration).getOfferById(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Read filtered list of offers
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffers(searchTerm?: string, options?: any): AxiosPromise<Array<Offer>> {
            return APApiFp(configuration).getOffers(searchTerm, options)(axios, basePath);
        },
        /**
         * 
         * @summary Read a single Participant
         * @param {number} id ID of Participant to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantById(id: number, options?: any): AxiosPromise<Participant> {
            return APApiFp(configuration).getParticipantById(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Read filtered list of participants
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipants(searchTerm?: string, options?: any): AxiosPromise<Array<Participant>> {
            return APApiFp(configuration).getParticipants(searchTerm, options)(axios, basePath);
        },
        /**
         * 
         * @summary Read filtered list of participants
         * @param {Array<number>} [marketIds] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantsByMarketIds(marketIds?: Array<number>, searchTerm?: string, options?: any): AxiosPromise<Array<Participant>> {
            return APApiFp(configuration).getParticipantsByMarketIds(marketIds, searchTerm, options)(axios, basePath);
        },
        /**
         * 
         * @summary Read a single Program
         * @param {number} id ID of Program to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgramById(id: number, options?: any): AxiosPromise<Program> {
            return APApiFp(configuration).getProgramById(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Read filtered list of programs
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrograms(searchTerm?: string, options?: any): AxiosPromise<Array<Program>> {
            return APApiFp(configuration).getPrograms(searchTerm, options)(axios, basePath);
        },
        /**
         * 
         * @summary Read all provided rule definitions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRuleDefinitions(options?: any): AxiosPromise<Array<ExtendedRuleDefinition>> {
            return APApiFp(configuration).getRuleDefinitions(options)(axios, basePath);
        },
        /**
         * 
         * @summary Update an existing Retailer OptIn OptOut configuration
         * @param {string} id ID of ROC to update
         * @param {string} ifMatch Version of the ROC which was being modified. Used to avoid lost updates of this entity in case someone else updates this entity at the same time.
         * @param {RetailerOptConfig} retailerOptConfig Retailer OptIn OptOut Configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfiguration(id: string, ifMatch: string, retailerOptConfig: RetailerOptConfig, options?: any): AxiosPromise<RetailerOptConfig> {
            return APApiFp(configuration).updateConfiguration(id, ifMatch, retailerOptConfig, options)(axios, basePath);
        },
        /**
         * 
         * @summary Update rules for the Retailer OptIn OptOut Configuration
         * @param {string} id ID of Retailer OptIn OptOut Configuration to update rule for
         * @param {string} ifMatch Version of the Retailer OptIn OptOut Configuration which was being modified. Used to avoid lost updates of this entity in case someone else updates this entity at the same time.
         * @param {Array<Rule>} rule Rules list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateConfigurationRules(id: string, ifMatch: string, rule: Array<Rule>, options?: any): AxiosPromise<Array<Rule>> {
            return APApiFp(configuration).updateConfigurationRules(id, ifMatch, rule, options)(axios, basePath);
        },
        /**
         * 
         * @summary Upload an (image) asset
         * @param {any} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAsset(file?: any, options?: any): AxiosPromise<UploadedAsset> {
            return APApiFp(configuration).uploadAsset(file, options)(axios, basePath);
        },
    };
};

/**
 * APApi - object-oriented interface
 * @export
 * @class APApi
 * @extends {BaseAPI}
 */
export class APApi extends BaseAPI {
    /**
     * 
     * @summary Create a new Retailer OptIn OptOut configuration
     * @param {RetailerOptConfig} retailerOptConfig Basic ROC data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public createConfiguration(retailerOptConfig: RetailerOptConfig, options?: any) {
        return APApiFp(this.configuration).createConfiguration(retailerOptConfig, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read a CodeList by name
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public getCodeListByName(name: string, options?: any) {
        return APApiFp(this.configuration).getCodeListByName(name, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read audit trails of changes made to an existing Retailer OptIn OptOut Configuration
     * @param {string} [id] ID of Retailer OptIn OptOut Configuration for which the list of audit trails are filtered
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public getConfigurationAuditTrails(id?: string, options?: any) {
        return APApiFp(this.configuration).getConfigurationAuditTrails(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read an ROC entry
     * @param {string} id ID of ROC to read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public getConfigurationByID(id: string, options?: any) {
        return APApiFp(this.configuration).getConfigurationByID(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read the rules for an existing Retailer OptIn OptOut Configuration
     * @param {string} id ID of Retailer OptIn OptOut Configuration to read the rules from
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public getConfigurationRules(id: string, options?: any) {
        return APApiFp(this.configuration).getConfigurationRules(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read all Retailer OptIn OptOut configurations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public getConfigurations(options?: any) {
        return APApiFp(this.configuration).getConfigurations(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read a single Market
     * @param {number} id ID of Market to read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public getMarketById(id: number, options?: any) {
        return APApiFp(this.configuration).getMarketById(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read filtered list of markets
     * @param {string} [searchTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public getMarkets(searchTerm?: string, options?: any) {
        return APApiFp(this.configuration).getMarkets(searchTerm, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read a single Offer
     * @param {number} id ID of Offer to read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public getOfferById(id: number, options?: any) {
        return APApiFp(this.configuration).getOfferById(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read filtered list of offers
     * @param {string} [searchTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public getOffers(searchTerm?: string, options?: any) {
        return APApiFp(this.configuration).getOffers(searchTerm, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read a single Participant
     * @param {number} id ID of Participant to read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public getParticipantById(id: number, options?: any) {
        return APApiFp(this.configuration).getParticipantById(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read filtered list of participants
     * @param {string} [searchTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public getParticipants(searchTerm?: string, options?: any) {
        return APApiFp(this.configuration).getParticipants(searchTerm, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read filtered list of participants
     * @param {Array<number>} [marketIds] 
     * @param {string} [searchTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public getParticipantsByMarketIds(marketIds?: Array<number>, searchTerm?: string, options?: any) {
        return APApiFp(this.configuration).getParticipantsByMarketIds(marketIds, searchTerm, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read a single Program
     * @param {number} id ID of Program to read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public getProgramById(id: number, options?: any) {
        return APApiFp(this.configuration).getProgramById(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read filtered list of programs
     * @param {string} [searchTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public getPrograms(searchTerm?: string, options?: any) {
        return APApiFp(this.configuration).getPrograms(searchTerm, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read all provided rule definitions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public getRuleDefinitions(options?: any) {
        return APApiFp(this.configuration).getRuleDefinitions(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update an existing Retailer OptIn OptOut configuration
     * @param {string} id ID of ROC to update
     * @param {string} ifMatch Version of the ROC which was being modified. Used to avoid lost updates of this entity in case someone else updates this entity at the same time.
     * @param {RetailerOptConfig} retailerOptConfig Retailer OptIn OptOut Configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public updateConfiguration(id: string, ifMatch: string, retailerOptConfig: RetailerOptConfig, options?: any) {
        return APApiFp(this.configuration).updateConfiguration(id, ifMatch, retailerOptConfig, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Update rules for the Retailer OptIn OptOut Configuration
     * @param {string} id ID of Retailer OptIn OptOut Configuration to update rule for
     * @param {string} ifMatch Version of the Retailer OptIn OptOut Configuration which was being modified. Used to avoid lost updates of this entity in case someone else updates this entity at the same time.
     * @param {Array<Rule>} rule Rules list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public updateConfigurationRules(id: string, ifMatch: string, rule: Array<Rule>, options?: any) {
        return APApiFp(this.configuration).updateConfigurationRules(id, ifMatch, rule, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Upload an (image) asset
     * @param {any} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof APApi
     */
    public uploadAsset(file?: any, options?: any) {
        return APApiFp(this.configuration).uploadAsset(file, options)(this.axios, this.basePath);
    }

}


/**
 * MPApi - axios parameter creator
 * @export
 */
export const MPApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Read an ROC entry
         * @param {string} id ID of ROC to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationByID(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getConfigurationByID.');
            }
            const localVarPath = `/configurations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all Retailer OptIn OptOut configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurations(options: any = {}): RequestArgs {
            const localVarPath = `/configurations`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read Retailer OptIn OptOut configurations linked to a specific program (specified by programId) optionally filtered by a retailerId
         * @param {number} programId System ID of the Program to which the OptIn OptOut Configurations are linked
         * @param {number} [retailerId] System ID of the Retailer who is set as the sponsor in the OptOut Configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgramConfigurations(programId: number, retailerId?: number, options: any = {}): RequestArgs {
            // verify required parameter 'programId' is not null or undefined
            if (programId === null || programId === undefined) {
                throw new RequiredError('programId','Required parameter programId was null or undefined when calling getProgramConfigurations.');
            }
            const localVarPath = `/programs/{programId}/configurations`
                .replace(`{${"programId"}}`, encodeURIComponent(String(programId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication roc_auth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("roc_auth", ["read:roc"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            if (retailerId !== undefined) {
                localVarQueryParameter['retailerId'] = retailerId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MPApi - functional programming interface
 * @export
 */
export const MPApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Read an ROC entry
         * @param {string} id ID of ROC to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationByID(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetailerOptConfig> {
            const localVarAxiosArgs = MPApiAxiosParamCreator(configuration).getConfigurationByID(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read all Retailer OptIn OptOut configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurations(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RetailerOptConfig>> {
            const localVarAxiosArgs = MPApiAxiosParamCreator(configuration).getConfigurations(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Read Retailer OptIn OptOut configurations linked to a specific program (specified by programId) optionally filtered by a retailerId
         * @param {number} programId System ID of the Program to which the OptIn OptOut Configurations are linked
         * @param {number} [retailerId] System ID of the Retailer who is set as the sponsor in the OptOut Configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgramConfigurations(programId: number, retailerId?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RetailerOptConfig>> {
            const localVarAxiosArgs = MPApiAxiosParamCreator(configuration).getProgramConfigurations(programId, retailerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MPApi - factory interface
 * @export
 */
export const MPApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Read an ROC entry
         * @param {string} id ID of ROC to read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationByID(id: string, options?: any): AxiosPromise<RetailerOptConfig> {
            return MPApiFp(configuration).getConfigurationByID(id, options)(axios, basePath);
        },
        /**
         * 
         * @summary Read all Retailer OptIn OptOut configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurations(options?: any): AxiosPromise<Array<RetailerOptConfig>> {
            return MPApiFp(configuration).getConfigurations(options)(axios, basePath);
        },
        /**
         * 
         * @summary Read Retailer OptIn OptOut configurations linked to a specific program (specified by programId) optionally filtered by a retailerId
         * @param {number} programId System ID of the Program to which the OptIn OptOut Configurations are linked
         * @param {number} [retailerId] System ID of the Retailer who is set as the sponsor in the OptOut Configurations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProgramConfigurations(programId: number, retailerId?: number, options?: any): AxiosPromise<Array<RetailerOptConfig>> {
            return MPApiFp(configuration).getProgramConfigurations(programId, retailerId, options)(axios, basePath);
        },
    };
};

/**
 * MPApi - object-oriented interface
 * @export
 * @class MPApi
 * @extends {BaseAPI}
 */
export class MPApi extends BaseAPI {
    /**
     * 
     * @summary Read an ROC entry
     * @param {string} id ID of ROC to read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPApi
     */
    public getConfigurationByID(id: string, options?: any) {
        return MPApiFp(this.configuration).getConfigurationByID(id, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read all Retailer OptIn OptOut configurations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPApi
     */
    public getConfigurations(options?: any) {
        return MPApiFp(this.configuration).getConfigurations(options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Read Retailer OptIn OptOut configurations linked to a specific program (specified by programId) optionally filtered by a retailerId
     * @param {number} programId System ID of the Program to which the OptIn OptOut Configurations are linked
     * @param {number} [retailerId] System ID of the Retailer who is set as the sponsor in the OptOut Configurations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MPApi
     */
    public getProgramConfigurations(programId: number, retailerId?: number, options?: any) {
        return MPApiFp(this.configuration).getProgramConfigurations(programId, retailerId, options)(this.axios, this.basePath);
    }

}


